import AccessIcon from "@/icons/__generated__/Access/Access32";
import BarFoodIcon from "@/icons/__generated__/BarFood/BarFood32";
import ChairIcon from "@/icons/__generated__/Chair/Chair32";
import CompanyPartyIcon from "@/icons/__generated__/CompanyParty/CompanyParty32";
import ExperiencesIcon from "@/icons/__generated__/Experiences/Experiences32";
import ExtraSpaceIcon from "@/icons/__generated__/ExtraSpace/ExtraSpace32";
import LightingProdIcon from "@/icons/__generated__/LightingProd/LightingProd32";
import OfficeSuppliesIcon from "@/icons/__generated__/OfficeSupplies/OfficeSupplies32";
import ParkingIcon from "@/icons/__generated__/Parking/Parking32";
import PartyIcon from "@/icons/__generated__/Party/Party32";
import ServingTrayIcon from "@/icons/__generated__/ServingTray/ServingTray32";
import SoundboardIcon from "@/icons/__generated__/Soundboard/Soundboard32";
import TableSettingIcon from "@/icons/__generated__/TableSetting/TableSetting32";
import { IntlShape } from "react-intl";
import { AddOnCategory, AddOnItem } from "./add-on-counter-types";

export const AddOnCategories: Record<string, AddOnCategory> = {
  AV_EQUIPMENT: "av_equipment",
  DROP_OFFS_DELIVERIES: "dropoffs_deliveries",
  EXPERIENCES: "experiences",
  EXTRA_SPACE: "extra_space",
  FOOD_DRINKS: "food_drinks",
  FURNITURE: "furniture",
  OFFICE_SUPPLIES: "office_supplies",
  PARKING: "parking",
  PARTY_ADDONS: "party_addons",
  PRODUCTION_EQUIPMENT: "production_equipment",
  STAFFING: "staffing",
  TABLE_SETTINGS: "table_settings",
  OTHER: "other",
};

export const getCostString = (intl: IntlShape, addOnItem: AddOnItem) => {
  const cost = intl.formatNumber(addOnItem.cost, {
    style: "currency",
    currency: addOnItem.currency,
  });
  switch (addOnItem.costBasis) {
    case "per_item":
      return cost;
    case "per_hour":
      return intl.formatMessage(
        {
          defaultMessage: "{cost}/hr",
        },
        { cost },
      );
    case "per_person":
      return intl.formatMessage(
        {
          defaultMessage: "{cost}/person",
        },
        { cost },
      );
    case "flat_fee":
      return intl.formatMessage(
        {
          defaultMessage: "{cost} flat fee",
        },
        { cost },
      );
  }
};

export const getCategoryString = (intl: IntlShape, category: AddOnCategory) => {
  switch (category) {
    case AddOnCategories.AV_EQUIPMENT:
      return intl.formatMessage({
        defaultMessage: "A/V equipment",
      });
    case AddOnCategories.DROP_OFFS_DELIVERIES:
      return intl.formatMessage({
        defaultMessage: "Dropoffs / deliveries",
      });
    case AddOnCategories.EXPERIENCES:
      return intl.formatMessage({
        defaultMessage: "Experiences",
      });
    case AddOnCategories.EXTRA_SPACE:
      return intl.formatMessage({
        defaultMessage: "Extra space",
      });
    case AddOnCategories.FOOD_DRINKS:
      return intl.formatMessage({
        defaultMessage: "Food and drinks",
      });
    case AddOnCategories.FURNITURE:
      return intl.formatMessage({
        defaultMessage: "Furniture",
      });
    case AddOnCategories.OFFICE_SUPPLIES:
      return intl.formatMessage({
        defaultMessage: "Office supplies",
      });
    case AddOnCategories.PARKING:
      return intl.formatMessage({
        defaultMessage: "Parking",
      });
    case AddOnCategories.PARTY_ADDONS:
      return intl.formatMessage({
        defaultMessage: "Party add-ons",
      });
    case AddOnCategories.PRODUCTION_EQUIPMENT:
      return intl.formatMessage({
        defaultMessage: "Production equipment",
      });
    case AddOnCategories.STAFFING:
      return intl.formatMessage({
        defaultMessage: "Staffing and services",
      });
    case AddOnCategories.TABLE_SETTINGS:
      return intl.formatMessage({
        defaultMessage: "Table settings",
      });
    case AddOnCategories.OTHER:
      return intl.formatMessage({
        defaultMessage: "Other",
      });
    default:
      return intl.formatMessage({
        defaultMessage: "Other",
      });
  }
};

export const getCategoryIcon = (category: AddOnCategory) => {
  switch (category) {
    case AddOnCategories.AV_EQUIPMENT:
      return <SoundboardIcon />;
    case AddOnCategories.DROP_OFFS_DELIVERIES:
      return <AccessIcon />;
    case AddOnCategories.EXPERIENCES:
      return <CompanyPartyIcon />;
    case AddOnCategories.EXTRA_SPACE:
      return <ExtraSpaceIcon />;
    case AddOnCategories.FOOD_DRINKS:
      return <BarFoodIcon />;
    case AddOnCategories.FURNITURE:
      return <ChairIcon />;
    case AddOnCategories.OFFICE_SUPPLIES:
      return <OfficeSuppliesIcon />;
    case AddOnCategories.PARKING:
      return <ParkingIcon />;
    case AddOnCategories.PARTY_ADDONS:
      return <PartyIcon />;
    case AddOnCategories.PRODUCTION_EQUIPMENT:
      return <LightingProdIcon />;
    case AddOnCategories.STAFFING:
      return <ServingTrayIcon />;
    case AddOnCategories.TABLE_SETTINGS:
      return <TableSettingIcon />;
    case AddOnCategories.OTHER:
    default:
      return <ExperiencesIcon />;
  }
};
